var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogosJira(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.8987 0H33.2793C33.2793 4.02501 34.8782 7.88517 37.7243 10.7313C40.5704 13.5774 44.4306 15.1763 48.4556 15.1763H54.6487V21.1559C54.6541 29.5299 61.4411 36.3172 69.8152 36.3226V2.91648C69.8152 1.30621 68.5098 0 66.8987 0Z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2638 16.7513H16.6447C16.6499 25.1254 23.4369 31.9126 31.8112 31.9181H38.0043V37.9168C38.0149 46.2908 44.8066 53.0734 53.1806 53.0734V19.6684C53.1806 18.0576 51.8746 16.7516 50.2638 16.7516V16.7513Z",
    fill: "url(#paint0_linear_18_269)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6194 33.493H0C0 41.8747 6.79492 48.6694 15.1763 48.6694H21.3888V54.6486C21.3943 63.015 28.1695 69.7993 36.5362 69.8151V36.4098C36.5362 34.799 35.2302 33.493 33.6194 33.493Z",
    fill: "url(#paint1_linear_18_269)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_269",
    x1: 52.4612,
    y1: 16.8098,
    x2: 38.2469,
    y2: 31.6418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_269",
    x1: 36.7791,
    y1: 33.6583,
    x2: 20.3368,
    y2: 49.8354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosJira);
export default __webpack_public_path__ + "static/media/logos_jira.36c17ad5ad8756535ecc8286d0fab9ad.svg";
export { ForwardRef as ReactComponent };